import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import TeaserPhoto from 'components/TeaserPhoto';
import './index.sass';
import { Skeleton } from '@mui/material';

const { block, el } = bem('short-2-rows-teaser');
export const Short2RowsTeaser = ({ specialist }) => {
    const { name, specialisation, photoResized, photo } = specialist.data;
    const specialistPhoto = photoResized || photo;
    return (
        <div className={block()}>
            <div className={el('photo')}>
                <TeaserPhoto src={specialistPhoto} alt={`Фото специалиста ${name}`} />
            </div>
            <div className={el('name-block')}>
                <div className={el('speciality')}><Text>{specialisation}</Text></div>
                <div className={el('name')}><Text serif={true} dangerouslySetInnerHTML={{__html: name}} /></div>
            </div>
        </div>
    )
}

export const Short2RowsTeaserSkeleton = () => {
    return (
        <div className={block()}>
            <div className={el('photo')}>
                <Skeleton variant={'rounded'} style={{paddingTop: '100%'}} />
            </div>
            <div className={el('name-block')} style={{width: '100%'}}>
                <div className={el('speciality')} ><Text><Skeleton width={'20%'}/></Text></div>
                <div className={el('name')} ><Text><Skeleton width={'30%'}/></Text></div>
            </div>
        </div>
    )
}
